import { IFile } from '../../helpers/Interfaces';
import DocumentButton from '../DocumentButton/DocumentButton';
import FileUploadUI from '../FileUploadUI/FileUploadUI';
import Stepper from '../Stepper/Stepper';

import "./BulkUploadAppointments.scss";

type SelectFileProps = {
    loading: boolean;
    setLoading: CallableFunction;
    media: IFile[];
    setMedia: CallableFunction;
    setShowAlert: CallableFunction;
    next: CallableFunction;
}

export default function SelectFile(props: SelectFileProps) {
    return (
        <div className="upload-file">
            <div className="stepper">
                <Stepper steps={[
                    { circleStyle: "active", descriptionStyle: "description-active", description: "Select File" },
                    { circleStyle: "inactive", descriptionStyle: "description-inactive", description: "Upload" }
                ]} />
            </div>
            <FileUploadUI removeFile={() => { }} setLoading={props.setLoading} setMedia={props.setMedia} media={props.media}
                setShowAlert={props.setShowAlert} showDelete={false} acceptedFileTypes={[".xls", ".xlsx", ".csv"]}
                removeMulitpleFiles={() => { }} />
            <div className="footer-btn">
                <div className='next-button-content'>
                    <div className="button">
                        <DocumentButton loading={props.loading} onClick={() => { props.next() }} text={"Next"} />
                    </div>
                </div>
            </div>
        </div>
    )
} 
